<template>
  <div
    id="videos"
    class="pt-16"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="500"
  >
    <Title class="mb-5" text="Videos" />
    <LoadingSpinner v-if="loading.display" :message="loading.message" />
    <div v-else>
      <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
        <div v-for="video in featuredVideos" :key="video.id">
          <EachVideo :video="video" :playVideo="true" />
        </div>
      </div>
    </div>

    <ViewAll v-if="!noVideos" />

    <LineBreak />
  </div>
</template>

<script>
import { generateFullPath } from "../../../utils/fileHelpers";
import Title from "../Title.vue";
import LineBreak from "../../LineBreak.vue";
import EachVideo from "./EachVideo.vue";
import ViewAll from "../../ViewAll.vue";
import LoadingSpinner from "../../LoadingSpinner.vue";
import initData from "../../../mixins/initData";
import { mapGetters } from "vuex";
import loader from "../../../mixins/loader";

export default {
  name: "FeaturedVideos",
  mixins: [initData, loader],

  props: {
    videos: Array,
  },

  components: {
    Title,
    LineBreak,
    EachVideo,
    ViewAll,
    LoadingSpinner,
  },

  computed: {
    ...mapGetters(["directory", "videosID", "featured"]),

    featuredVideos() {
      return this.featured("videos");
    },

    noVideos() {
      return this.directory.videos.length === 0;
    },

    downloadLink() {
      return generateFullPath("/files/videos.zip");
    },
  },

  async created() {
    if (this.noVideos) {
      await this.load(this.initData(this.videosID), "Loading videos");
    }
  },
};
</script>